export default __webpack_public_path__ + "static/spProductImage-3c4c35046feb41c8d4637616856245c2.webp";